import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful'

export interface TypeLessonDataFields {
  title: EntryFieldTypes.Symbol
  precinct: EntryFieldTypes.Symbol<
    | 'fast-phonics-peaks'
    | 'mathseeds-lessons'
    | 'reading-eggs-reading'
    | 'reading-eggs-spelling'
    | 'reading-eggs-storylands'
    | 'reading-eggspress-reading'
    | 'reading-eggspress-spelling'
    | 'writing-legends-writing'
  >
  map?: EntryFieldTypes.Integer
  mapTopic?: EntryFieldTypes.Symbol
  activityNumber: EntryFieldTypes.Integer
  quiz?: EntryFieldTypes.Boolean
  focusSounds?: EntryFieldTypes.Array<EntryFieldTypes.Symbol>
  wordsRead?: EntryFieldTypes.Array<EntryFieldTypes.Symbol>
  alternatives?: EntryFieldTypes.Array<EntryFieldTypes.Symbol>
  wordCount?: EntryFieldTypes.Integer
  phase?: EntryFieldTypes.Integer
  phonicallyDecodableWords?: EntryFieldTypes.Array<EntryFieldTypes.Symbol>
  vocabulary?: EntryFieldTypes.Array<EntryFieldTypes.Symbol>
  phonicLettersAndSounds?: EntryFieldTypes.Array<EntryFieldTypes.Symbol>
  highFrequencySightWords?: EntryFieldTypes.Array<EntryFieldTypes.Symbol>
  readingLevel?: EntryFieldTypes.Symbol
  skills?: EntryFieldTypes.Array<EntryFieldTypes.Symbol>
  focusSoundWords?: EntryFieldTypes.Array<EntryFieldTypes.Symbol>
  challenge?: EntryFieldTypes.Array<EntryFieldTypes.Symbol>
  textType?: EntryFieldTypes.Array<EntryFieldTypes.Symbol>
  focusSummary?: EntryFieldTypes.Symbol
  focusActivities?: EntryFieldTypes.Array<EntryFieldTypes.Symbol>
}

export type TypeLessonDataSkeleton = EntrySkeletonType<TypeLessonDataFields, 'lessonData'>
export type TypeLessonData<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<
  TypeLessonDataSkeleton,
  Modifiers,
  Locales
>

export function isTypeLessonData<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
  entry: Entry<EntrySkeletonType, Modifiers, Locales>,
): entry is TypeLessonData<Modifiers, Locales> {
  return entry.sys.contentType.sys.id === 'lessonData'
}

export type TypeLessonDataWithoutLinkResolutionResponse = TypeLessonData<'WITHOUT_LINK_RESOLUTION'>
export type TypeLessonDataWithoutUnresolvableLinksResponse = TypeLessonData<'WITHOUT_UNRESOLVABLE_LINKS'>
export type TypeLessonDataWithAllLocalesResponse<Locales extends LocaleCode = LocaleCode> = TypeLessonData<
  'WITH_ALL_LOCALES',
  Locales
>
export type TypeLessonDataWithAllLocalesAndWithoutLinkResolutionResponse<Locales extends LocaleCode = LocaleCode> =
  TypeLessonData<'WITHOUT_LINK_RESOLUTION' | 'WITH_ALL_LOCALES', Locales>
export type TypeLessonDataWithAllLocalesAndWithoutUnresolvableLinksResponse<Locales extends LocaleCode = LocaleCode> =
  TypeLessonData<'WITHOUT_UNRESOLVABLE_LINKS' | 'WITH_ALL_LOCALES', Locales>
